const AUTHENTICATION_KEY = 'authentication';
let activeMocoEnv = null;

const setActiveMocoEnv = function(mocoEnv) {
  activeMocoEnv = mocoEnv;
  const storedCredentials = JSON.parse(localStorage.getItem(getEnvironmentKey(AUTHENTICATION_KEY)) || '{}');
  storedCredentials.activeMocoEnv = mocoEnv;
  localStorage.setItem(getEnvironmentKey(AUTHENTICATION_KEY), JSON.stringify(storedCredentials));
}

const setAuthentication = function(email, mocoUserID, mocoApiKey, mocoEnv, jwt) {
  setActiveMocoEnv(mocoEnv);
  setItem(AUTHENTICATION_KEY, { email, mocoUserID, mocoApiKey, mocoEnv, jwt });
}

const getAuthentication = function() {
  return getItem(AUTHENTICATION_KEY) ?? {};
}

const addSQTJWT = function(jwt) {
  const authentication = getAuthentication();
  authentication.jwt = jwt;
  setItem(AUTHENTICATION_KEY, authentication);
}

const getStoredEnvs = function() {
  try {
    const storedCredentials = JSON.parse(localStorage.getItem(getEnvironmentKey(AUTHENTICATION_KEY)) || '{}');

    return Object.keys(storedCredentials)
      .filter(key => storedCredentials[key].email)
      .map(key => ({
        mocoEnv: key ?? '',
        email: storedCredentials[key].email ?? '',
        mocoApiKey: storedCredentials[key].mocoApiKey ?? ''
      }));
  } catch (e) {
    localStorage.setItem(getEnvironmentKey(AUTHENTICATION_KEY), null);
  }
}

const clearAuthentication = function(keepEmail) {
  setAuthentication(keepEmail ? getAuthentication().email : null, null, null, activeMocoEnv, null);
}

const initializeActiveMocoEnv = function() {
  activeMocoEnv = JSON.parse(localStorage.getItem(getEnvironmentKey(AUTHENTICATION_KEY)) ?? '{}').activeMocoEnv ?? null;
}

const setItem = function(key, value) {
  if (activeMocoEnv === null) {
    return null;
  }

  try {
    const currentValue = JSON.parse(localStorage.getItem(getEnvironmentKey(key)) ?? '{}');
    currentValue[activeMocoEnv] = value;

    localStorage.setItem(getEnvironmentKey(key), JSON.stringify(currentValue));
  } catch (e) {
    localStorage.setItem(getEnvironmentKey(key), null);
  }
}

const getItem = function(key) {
  if (activeMocoEnv === null) {
    return null;
  }

  try {
    const currentObject = JSON.parse(localStorage.getItem(getEnvironmentKey(key)) ?? '{}');
    return currentObject[activeMocoEnv] ?? null;
  } catch (e) {
    localStorage.setItem(getEnvironmentKey(key), null);
    return null;
  }
}

const getEnvironmentKey = function(key) {
  return `${key}_${global.LOCAL_STORAGE_ENV}`;
}

// TODO Kann mann beim nächsten Release wieder löschen
/* Local Storage Migration: authentication: { staging: {}} => authentication_staging: {}. */
const storagateAuthData = JSON.parse(localStorage.getItem(AUTHENTICATION_KEY) || '{}');
Object.keys(storagateAuthData).forEach(appEnvKey => {
  const authEnvData = storagateAuthData[appEnvKey];
  if (authEnvData.mocoEnv) {
    const activeMocoEnv = authEnvData.mocoEnv;
    const migratedAuthData = {
      activeMocoEnv: activeMocoEnv,
      [activeMocoEnv]: authEnvData
    }
    localStorage.setItem(`${AUTHENTICATION_KEY}_${appEnvKey}`, JSON.stringify(migratedAuthData));

    const storageKeysToMigrate = ['enabled_rules', 'other_settings'];
    storageKeysToMigrate.forEach(storageKeyToMigrate => {
      const storageData = JSON.parse(localStorage.getItem(storageKeyToMigrate) || '{}');
      const envData = {
        [activeMocoEnv]: storageData[appEnvKey]
      };
      localStorage.setItem(`${storageKeyToMigrate}_${appEnvKey}`, JSON.stringify(envData));
    });
  }
});
[AUTHENTICATION_KEY, 'enabled_rules', 'other_settings'].forEach(storageKeyToMigrate => {
    localStorage.removeItem(storageKeyToMigrate);
});
/* End of Local Storage Migration */


initializeActiveMocoEnv();

export default {
  setAuthentication,
  getAuthentication,
  clearAuthentication,
  addSQTJWT,
  setItem,
  getItem,
  setActiveMocoEnv,
  getStoredEnvs
}